type FileName = {
  fileName: string
  fileExtension: string
}
const hasExtension = (filename: string) => filename.split('.').length > 1

const cleanFilename = (filename: string) =>
  filename && hasExtension(filename) ? filename.split('.').slice(0, -1).join('.') : filename

const extension = (filename: string) =>
  filename && hasExtension(filename) ? `.${filename.split('.').pop()}` : ''

export const splitFileName = (filename: string): FileName => {
  return {
    fileName: cleanFilename(filename),
    fileExtension: extension(filename),
  }
}
